"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLayout = exports.Grid = exports.Box = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./layout.pc.css");
const Box = ({ className, vertical, justifySpaceBetween, alignEnd, alignCenter, alignItemsCenter, fill, halfGap, gap, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_ab42772f', '_730a33f7', '_pub-730a33f7', '_pub-3c25d522', {
            '_730a33f7_vertical _pub-730a33f7_vertical _pub-3c25d522_vertical vertical': vertical,
            '_730a33f7_justify-space-between _pub-730a33f7_justify-space-between _pub-3c25d522_justify-space-between justify-space-between': justifySpaceBetween,
            '_730a33f7_align-end _pub-730a33f7_align-end _pub-3c25d522_align-end align-end': alignEnd,
            '_730a33f7_align-center _pub-730a33f7_align-center _pub-3c25d522_align-center align-center': alignCenter,
            '_730a33f7_align-items-center _pub-730a33f7_align-items-center _pub-3c25d522_align-items-center align-items-center': alignItemsCenter,
            '_730a33f7_fill _pub-730a33f7_fill _pub-3c25d522_fill fill': fill,
            '_730a33f7_half-gap _pub-730a33f7_half-gap _pub-3c25d522_half-gap half-gap': halfGap,
        }, className), style: { '--gap:': gap } }, children));
};
exports.Box = Box;
const Grid = ({ templateColumns, children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_4221d21a', '_730a33f7', '_pub-730a33f7', '_pub-3c25d522'), style: { '--grid-template-columns': templateColumns } }, children));
};
exports.Grid = Grid;
const FormLayout = ({ className, testId, onSubmit, children, }) => {
    return (react_1.default.createElement("form", { className: (0, clsx_1.default)('_f49e9337', '_730a33f7', '_pub-730a33f7', '_pub-3c25d522', '_730a33f7_v3', '_pub-730a33f7_v3', '_pub-3c25d522_v3', 'v3', '_730a33f7_form-layout', '_pub-730a33f7_form-layout', '_pub-3c25d522_form-layout', 'form-layout', className), "data-testid": testId, onSubmit: onSubmit }, children));
};
exports.FormLayout = FormLayout;
//# sourceMappingURL=layout.js.map